// src/FlightBreakdown.js
import React, { useState } from 'react';
// REMOVE NavBar import if no longer needed here
// import NavBar from './NavBar';
// REMOVE Box import if no longer needed here (keep if used elsewhere)
// import { Box } from '@mui/material';
import './FlightBreakdown.css';
import PasteData from './PasteData';
import Breakdown from './Breakdown';

function FlightBreakdownPage() {
  const [flights, setFlights] = useState([]);
  const [isPriorityFlight, setIsPriorityFlight] = useState(false);
  const [hotThreshold, setHotThreshold] = useState(30);
  const [coldThresholdHours, setColdThresholdHours] = useState(3);

  const handleParametersChange = (params) => {
    setIsPriorityFlight(params.isPriorityFlight);
    setHotThreshold(params.hotThreshold);
    setColdThresholdHours(params.coldThresholdHours);
  };

  // The main div now directly contains the page-specific content
  return (
    <div style={{ minHeight: 'calc(100vh - 84px)', color: '#fff' }}> {/* Adjust minHeight if needed */}
      {/* NavBar and Offset Box are REMOVED from here */}

      <div className="breakdown-container">
        <div className="breakdown-card">
          <h2>Flight Breakdown</h2>
          <p>Paste your TDR and Brock / SmartSuite data below, then run the breakdown.</p>
          <Breakdown
            flights={flights}
            onParametersChange={handleParametersChange}
            isPriorityFlight={isPriorityFlight}
            hotThreshold={hotThreshold}
            coldThresholdHours={coldThresholdHours}
          />
          <PasteData
            setFlights={setFlights}
            breakdownParams={{
              isPriorityFlight,
              hotThreshold,
              coldThresholdHours
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default FlightBreakdownPage;
